(function(){
  const BOX='[data-rpd-price-container][data-rpd-kind="machine"]';

  function clean(v){return String(v||'').toLowerCase().trim()}
  function parseItalianSchedule(value){
    const m=String(value||'').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if(!m)return null;
    return Date.UTC(Number(m[1]),Number(m[2])-1,Number(m[3]),Number(m[4])-2,Number(m[5]));
  }
  function campaignActive(box){
    const mode=clean(box?.dataset.rpdFaberDaysMode||'off');
    if(mode==='on')return true;
    if(mode!=='schedule')return false;
    const start=parseItalianSchedule(box?.dataset.rpdFaberDaysStart);
    const end=parseItalianSchedule(box?.dataset.rpdFaberDaysEnd);
    if(start===null||end===null||end<=start)return false;
    const now=Date.now();
    return now>=start&&now<end;
  }
  function money(cents, format){
    const value=(Number(cents)||0)/100;
    const token=String(format||'€{{amount_with_comma_separator}}');
    const fixed=value.toFixed(2).split('.');
    const integer=fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');
    const comma=integer+','+fixed[1];
    const dot=fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g,',')+'.'+fixed[1];
    return token
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,comma)
      .replace(/\{\{\s*amount\s*\}\}/g,dot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,String(Math.round(value)))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,integer.replace(/\./g,' ')+','+fixed[1]);
  }

  function render(){
    const boxes=Array.from(document.querySelectorAll(BOX));
    if(!boxes.length)return;

    const active=campaignActive(boxes[0]);

    // Faber Days is a standalone campaign: never show the old bundle summary while active.
    document.querySelectorAll('[data-rpd-bundle-summary]').forEach(root=>{
      root.style.display=active?'none':'';
    });

    if(!active)return;

    boxes.forEach(box=>{
      const original=box.querySelector('[data-rpd-price-original]');
      const final=box.querySelector('[data-rpd-price-final]');
      const badge=box.querySelector('[data-rpd-price-badge]');
      const eligible=box.dataset.rpdFaberDaysEligible==='true';
      const base=Number(box.dataset.rpdFaberDaysBaseCents||box.dataset.rpdBaseCents||0);
      const discount=Number(box.dataset.rpdFaberDaysDiscountCents||0);
      const hasPromo=eligible && base>0 && discount>0;
      const promo=hasPromo?Math.max(0,base-discount):base;

      const moneyFormat=box.dataset.rpdFaberDaysMoneyFormat||'€{{amount_with_comma_separator}}';
      const originalText=money(base,moneyFormat);
      const finalText=money(promo,moneyFormat);
      const originalDisplay=hasPromo?'':'none';

      // Avoid needless DOM writes: if price/state are already correct, leave them untouched.
      if(original){
        if(original.textContent!==originalText)original.textContent=originalText;
        if(original.style.display!==originalDisplay)original.style.display=originalDisplay;
        if(original.style.visibility)original.style.visibility='';
      }
      if(final && base>0 && final.textContent!==finalText)final.textContent=finalText;

      // No generic bundle badge / dash during Faber Days.
      if(badge){
        if(badge.textContent)badge.textContent='';
        if(badge.style.display!=='none')badge.style.display='none';
      }

      const rendered=hasPromo?'true':'false';
      if(box.dataset.rpdFaberDaysRendered!==rendered)box.dataset.rpdFaberDaysRendered=rendered;
    });
  }

  let raf=0;
  function schedule(){
    cancelAnimationFrame(raf);
    raf=requestAnimationFrame(()=>requestAnimationFrame(render));
  }

  // Only final grouped state owns the promo render.
  document.addEventListener('grouped:entry-applied',schedule);
  document.addEventListener('rpd:faber-days:refresh',schedule);
  document.addEventListener('shopify:section:load',schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);
  else schedule();
})();
